module.exports = __webpack_public_path__ + "static/media/currently_active_page.4d348bbf.svg";